import { render, staticRenderFns } from "./systemData.vue?vue&type=template&id=d4700f5c&"
import script from "./systemData.vue?vue&type=script&lang=js&"
export * from "./systemData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports